import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { useSubMenu } from "../../../../../empreenderUI/SubMenuContext";
import ScrollArea from "../../../../../empreenderUI/components/ScrollArea";
import Heading from "../../../../../empreenderUI/ui/Heading/Heading";
import { translations } from "../../../../../utils/language";

const EmailContent = () => {
	const { toggle } = useSubMenu();
	const history = useHistory();
	const language = useSelector((state) => state.reducerLanguage);

	return (
		<ScrollArea>
			<Heading
				header={translations["sidebar-email"]?.[language.data] || "E-mail"}
				text={
					translations["Personalizar e-mail"]?.[language.data] ||
					"Edite o e-mail na área de preview"
				}
				onClick={() => {
					history.push("/personalizar");
					toggle("personalizar");
				}}
			/>
			<div className="px-6 py-4">
				<p className="text-sm text-gray-500">
					{translations["thema-email-helper"][language.data]}
				</p>
			</div>
		</ScrollArea>
	);
};

export default EmailContent;
